import React, { memo } from "react";

import {
	Modal, Button
} from "react-bootstrap";


const WaitQuestionAudioFinish = memo( function WaitQuestionAudioFinish({
	isOpen, handler
}) {

	const toggle = () => {
		handler(prev => false);
	};

	return (
    <Modal show={isOpen} size="md" centered contentClassName="mock-container">
      <Modal.Header style={{ padding: "0px" }} className="mock-popup-header">
        <div className="d-flex justify-content-end align-items-center p-2">
          <button onClick={toggle} className="modal-close-btn">
            ×
          </button>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex gap-2 align-items-center mock-resource-text">
          Please wait for question audio to be finished.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="secondary"
          className="mock-test-modal-button"
          onClick={toggle}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default WaitQuestionAudioFinish;